import { ToastProvider } from 'react-toast-notifications';
import React, { Fragment, useState, useRef } from 'react';
import { Row } from 'react-bootstrap';
import language from '../../config/es';

import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';

import { es_entero } from '../../config/validate';
import { findByConcept } from '../../redux/type.duck';
import app from '../../config/application';
import {
  findBySocieties,
  findBy,
  createConnectionSftp,
  deleteConnectionSftp,
  updateConnectionSftp,
} from '../../redux/connectionSftp.duck';
import { findSocieties } from '../../redux/society.duck';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  createFormState,
  addFieldError,
  renderDeleteAction,
  toIdList,
  requireSelection,
  requireValues,
} from '../../components/Crud/crudHelpers';
import {
  RequiredFieldsAlert,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudPage,
} from '../../components/Crud/CrudLayout';

const ConnectionSftp = () => {
  const ref = useRef();
  const dispatch = useAppDispatch();
  const [showloadingEnvironment, setShowloadingEnvironment] = useState(false);
  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    finishDelete,
  } = useCrudState({
    ...createFormState(),
    id: null,
    connections: [],
    types: [],
    responseCreate: [],
    responseEdit: [],
    listEnvironment: [],
    environment: { value: 0, label: '', error: '' },
    listEntities: [],
    entity: { id: 0, value: 0, label: '', error: '' },
    listSociety: [],
    society: { value: 0, label: '', error: '' },
    showloadingEntity: true,
    showloadingSociety: false,
    concept: { value: '', error: '' },
    conceptData: { value: '', error: '' },
    name: { value: '', error: '' },
    code: { value: '', error: '' },
    value: { value: '', error: '' },
    host: { value: '', error: '' },
    user: { value: '', error: '' },
    pass: { value: '', error: '' },
    path: { value: '', error: '' },
    port: { value: '', error: '' },
    username: 'admin',
    disableUpdate: false,
    auth: JSON.parse(sessionStorage.getItem('user')),
    error: '',
  });
  data.listEnvironment = useSelector((store) => store.typeReducer.types);
  data.listSociety = useSelector((store) => store.societyReducer.societies);
  useCrudLifecycle(ref, data, () => {
    void loadSocieties();
    void loadTypes();
    data.pendingData = false;
    refreshState();
  });
  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    data.showloadingSociety = true;
    initTable();
    refreshState();
  };

  const initTable = () => {
    data.columns = [
      buildEditColumn(handleButtonEdit, { width: '40px' }),
      {
        name: language.messages.titleEnvironment,
        sortable: false,
        wrap: true,
        width: '150px',
        cell: (row) => (
          <span>
            <div className="small text-uppercase">
              {row.typeEnvironment.name}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.labelUser,
        sortable: false,
        wrap: true,
        width: '250px',
        aling: 'left',
        cell: (row) => (
          <span>
            <div className="small text-uppercase">
              <i className="fa fa-user"></i>
              {row.user}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.labelPath,
        sortable: false,
        wrap: true,
        width: '300px',
        cell: (row) => (
          <span>
            <div className="small text-uppercase text-primary ">{row.host}</div>
            <div className="text-muted small text-uppercase">{row.path}</div>
          </span>
        ),
      },
    ];
    updateState(data.columns, 'columns');
  };

  const loadEntities = async (value) => {
    data.showloadingEntity = false;
    data.listEntities = await dispatch(findBySocieties(value.value));
    data.showloadingEntity = true;
    updateState(true, 'showloadingEntity');
    refreshState();
  };

  const handleButtonEdit = (row) => {
    data.id = row.id;
    data.environment = {
      value: row.typeEnvironment.id,
      label: row.typeEnvironment.name,
      error: '',
    };
    data.host.value = row.host;
    data.user.value = row.user;
    data.pass.value = row.password;
    data.path.value = row.path;
    data.port.value = row.port;
    refreshState();
  };

  const loadConnectionsSftp = async (value) => {
    data.pendingData = true;
    data.connections = await dispatch(
      findBy(value.value, data.auth.id.user.username)
    );
    initTable();
    data.pendingData = false;
    refreshState();
  };

  const loadTypes = async () => {
    await dispatch(findByConcept(app.data.types.environment));
    setShowloadingEnvironment(true);
  };

  const updateSelect = async (value, id) => {
    switch (id) {
      case 'society':
        data.society = value;
        void loadEntities(value);
        break;
      case 'entity':
        data.entity = value;
        void loadConnectionsSftp(value);
        void loadEntities(data.society);
        break;
      case 'environment':
        data.environment = value;
        break;
      default:
        break;
    }
    refreshState();
  };

  const onChange = (event) => {
    switch (event.target.name) {
      case 'host':
        data.host.value = event.target.value;
        data.host.error = '';
        break;
      case 'user':
        data.user.value = event.target.value;
        data.user.error = '';
        break;
      case 'pass':
        data.pass.value = event.target.value;
        data.pass.error = '';
        break;
      case 'path':
        data.path.value = event.target.value;
        data.path.error = '';
        break;
      case 'port':
        data.port.value = event.target.value;
        data.port.error = '';
        break;
      default:
        break;
    }
    refreshState();
  };

  // Recarga los catalogos y limpia el formulario tras guardar
  const reloadAfterSave = () => {
    void loadSocieties();
    void loadTypes();
    void loadEntities(data.society);
    void loadConnectionsSftp(data.entity);
    clearError();
    clearForm();
    refreshState();
  };

  const handleCreateResponse = (res) => {
    if (res.status === 200) {
      switch (res.data) {
        case 'OK':
          viewNotification(
            language.messages.msmRegisterDataSuccess,
            'success'
          );
          reloadAfterSave();
          break;
        case 'EXIST':
          viewNotification(
            language.messages.msmErrorExistConnection,
            'error'
          );
          data.pendingData = false;
          break;
        default:
          break;
      }
    } else {
      if (res.response.status === 403) {
        viewNotification(res.response.data, 'error');
      } else {
        // Incluye el caso 500
        viewNotification(language.messages.msmErrorExist, 'error');
      }
      data.pendingData = false;
    }
  };

  const saveData = async () => {
    validate();
    if (data.errors.length === 0) {
      data.enable = false;
      data.pendingData = true;
      refreshState();
      // Cuerpo comun del registro de conexion
      const buildJson = (entityId) => ({
        entity: { id: entityId },
        typeEnvironment: { id: data.environment.value },
        host: data.host.value,
        user: data.user.value,
        password: data.pass.value,
        path: data.path.value,
        port: data.port.value,
        status: 1,
        userAdmin: data.auth.id.user.username,
        society_id: data.society.value,
      });
      if (data.id === null) {
        let json = buildJson(data.entity.id);
        let res = await dispatch(
          createConnectionSftp(json, data.auth.id.user.username)
        );
        handleCreateResponse(res);
      } else {
        let json = { id: data.id, ...buildJson(data.entity.value) };
        let response = await dispatch(
          updateConnectionSftp(json, data.auth.id.user.username)
        );
        if (response.data === language.messages.messageNoAccessRegister) {
          viewNotification(language.messages.messageNoAccessRegister, 'error');
          data.pendingData = false;
        } else {
          viewNotification(
            language.messages.msmRegister.replace('{0}', data.entity.value),
            'success'
          );
          reloadAfterSave();
        }
      }
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
    data.enable = true;
    data.pendingData = false;
    refreshState();
  };

  const validate = () => {
    clearError();
    requireSelection(data, ['environment', 'entity', 'host', 'user', 'pass']);

    requireValues(data, ['environment', 'entity', 'host', 'user', 'pass', 'port']);
    if (!es_entero(data.port.value)) {
      addFieldError(data, 'port', language.messages.warningOnlyNumericSmall);
    }
    refreshState();
  };

  const cleaningForm = () => {
    clearError();
    clearForm();
    refreshState();
  };

  const clearError = () => {
    data.errors = [];
    data.entity.error = '';
    data.environment.error = '';
    data.host.error = '';
    data.user.error = '';
    data.pass.error = '';
    data.path.error = '';
    data.port.error = '';
  };

  // Reinicia los campos de la conexion
  const resetFields = () => {
    data.environment = { value: 0, label: '', error: '' };
    data.host = { value: '', error: '' };
    data.user = { value: '', error: '' };
    data.pass = { value: '', error: '' };
    data.path = { value: '', error: '' };
    data.port = { value: '', error: '' };
  };
  const clearForm = () => {
    data.editType = true;
    data.id = null;
    resetFields();
  };
  const reloadData = () => {
    data.pendingData = false;
    resetFields();
    void loadConnectionsSftp(data.entity);
    data.pendingData = true;
    refreshState();
  };

  const handleDelete = () => {
    void disableData();
  };
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      let lsDelete = toIdList(data.selectedRows);
      initStateDelete(false);

      let response = await dispatch(
        deleteConnectionSftp(lsDelete, data.auth.id.user.username)
      );
      finishDelete(response.code === undefined, response.message, reloadData);
    }
  };

  const contextActions = renderDeleteAction(
    handleDelete,
    data.enable,
    'Dar de Baja'
  );

  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <br />
      <CrudPage
        formCol={{ md: 5, xl: 4 }}
        formTitle={language.messages.type.title}
        form={
          <form autoComplete="off">
            <RequiredFieldsAlert textClassName="small " />
            <SelectField
              label={language.messages.society.title_society}
              loading={data.showloadingSociety}
              isDisabled={data.id !== null}
              name="society"
              options={data.listSociety}
              field={data.society}
              onChange={updateSelect}
              changeKey="society"
            />

            <SelectField
              label={language.messages.titleCEntityForm}
              loading={data.showloadingEntity}
              isDisabled={data.id !== null}
              className="text-uppercase small "
              name="entity"
              options={data.listEntities}
              value={{
                id: data.entity.id,
                value: data.entity.value,
                label: data.entity.label,
              }}
              error={data.entity.error}
              errorPosition="after"
              onChange={updateSelect}
              changeKey="entity"
            />

            <SelectField
              label={language.messages.titleEnvironment}
              loading={showloadingEnvironment}
              isDisabled={data.id !== null}
              className="text-uppercase small "
              name="environment"
              options={data.listEnvironment}
              field={data.environment}
              errorPosition="afterDiv"
              onChange={updateSelect}
              changeKey="environment"
            />
            <Row>
              <TextField
                col={{ md: 8 }}
                compact={false}
                className="small"
                label={language.messages.labelHost}
                name="host"
                field={data.host}
                onChange={onChange}
              />

              <TextField
                col={{ md: 4 }}
                compact={false}
                className="small"
                label={language.messages.sftp.port}
                name="port"
                field={data.port}
                onChange={onChange}
              />
            </Row>
            <TextField
              compact={false}
              className="small"
              label={language.messages.labelUser}
              placeholder="User"
              name="user"
              field={data.user}
              onChange={onChange}
            />

            <TextField
              compact={false}
              className="small"
              label={language.messages.labelPassword}
              type="password"
              placeholder="Pass"
              name="pass"
              field={data.pass}
              onChange={onChange}
            />
            <TextField
              compact={false}
              className="small"
              label={language.messages.labelPath}
              required={false}
              placeholder="Pass"
              name="path"
              field={data.path}
              onChange={onChange}
            />
            <CrudButtons
              data={data}
              wrapped
              onSave={saveData}
              onClear={cleaningForm}
              onReload={reloadData}
            />
          </form>
        }
        tableCol={{ md: 7, xl: 8 }}
        tableClassTitle=" text-uppercase text-capitalize"
        tableIcon="fa fa-list"
        tableTitle={language.messages.titleConnectionSftp}
        table={
          <CrudDataTable
            data={data}
            title={data.connections.length > 0 ? data.entity.label : ''}
            noHeader={data.connections.length === 0}
            rows={data.connections}
            onSelect={handleSelectRow}
            pointerOnHover={true}
            actions={contextActions}
          />
        }
      />
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <ConnectionSftp />
  </ToastProvider>
);
export default App;
